import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../services';
import { RegisterUser } from '../../models';
import { UserService } from '../../../dashboard/services';
import { UserPayload } from '../../../dashboard/models';
import { switchMap, take } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'kt-app-sign-up',
  imports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule],
  templateUrl: './sign-up.component.html',
  styleUrl: './sign-up.component.scss'
})
export class SignUpComponent {
  private fb = inject(FormBuilder);
  private authService = inject(AuthService);
  private userService = inject(UserService);
  private router = inject(Router)

  registerForm: FormGroup = this.fb.group(
    {
      fullName: ['', Validators.required],
      //companyName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
      confirmPassword: ['', [Validators.required]],
      agreeToTAC: ['', Validators.requiredTrue]
    },
    { validators: this.passwordMatchValidator }
  );

  passwordMatchValidator(group: FormGroup){
    const password = group.get('password')?.value;
    const confirmPassword = group.get('confirmPassword')?.value;

    return password === confirmPassword ? null : { passwordsDontMatch: true };
  }

  onSubmit(): void{
    if(this.registerForm.invalid){
      this.registerForm.markAllAsTouched();
      return;
    }

    const req : RegisterUser = this.registerForm.value;

    this.authService.register(req)
      .pipe(
        switchMap((res) => {
          const identityId = `${environment.identityIdPrefix}${res.userId}`;

          const userPayload: UserPayload = {
            identityId: identityId,
            fullName: req.fullName,
            email: req.email
          };
          return this.userService.createUser(userPayload);
        }),
        take(1)
      )
      .subscribe({
        next: () => {
          console.log('User registered and profile created successfully');
          this.router.navigateByUrl('/auth/login');
        },
        error: (err) => {
          console.log('Registration or profile creation failed', err);
        }
      });
  }
}
